export class ProdutoValorVendaCompraPreCadastroFormModel {
  constructor(public vCompra: string = '', public vPreco:string = '',public pLucro:string = '0') {}
}
